module.exports = __webpack_public_path__ + "static/media/background-desapega-mobile.20d6e5d0.jpg";